import service from "@/utils/request";

// 添加课程
interface createCourseData {
  subject_id: number;
  course_name: string;
  course_type: number;
  absent_rule: number;
  leave_rule: number;
  leave_cycle: number;
  leave_number?: number;
  icon_image?: string;
  cover_image?: string;
  detail?: string;
  course_spec: {
    name: string;
    quantity: string;
    price: string;
    unit_price: string;
  }[];
}
export const createCourse = (data: createCourseData) => {
  return service({
    url: "/api/v1/course/create",
    method: "post",
    data,
  });
};
// 编辑课程
interface editCourseData {
  subject_id: number;
  course_name: string;
  course_type: number;
  absent_rule: number;
  leave_rule: number;
  leave_cycle: number;
  leave_number?: number;
  icon_image?: string;
  cover_image?: string;
  detail?: string;
  course_spec: {
    name: string;
    quantity: string;
    price: string;
    unit_price: string;
    course_spec_id: number;
  }[];
  course_id: number;
}
export const editCourse = (data: editCourseData) => {
  return service({
    url: "/api/v1/course/modify",
    method: "post",
    data,
  });
};
// 课程购买状态变更
interface setCourseStatusData {
  course_id: number;
  sales_status: number;
}
export const setCourseStatus = (data: setCourseStatusData) => {
  return service({
    url: "/api/v1/course/modify/status",
    method: "post",
    data,
  });
};
// 课程列表
interface courseListData {
  page?: number;
  page_size?: number;
  course_name?: string;
  subject_id?: number;
  sales_status?: number;
}
export const courseList = (params: courseListData) => {
  return service({
    url: "/api/v1/course/list",
    method: "get",
    params,
  });
};
// 课程详情
interface courseDetailData {
  course_id: number;
}
export const courseDetail = (params: courseDetailData) => {
  return service({
    url: "/api/v1/course/detail",
    method: "get",
    params,
  });
};
// 获取学员购买课程信息
interface studentCourseDetailInter {
  course_ids: number[];
  product_ids?: number[];
  student_id?: number;
}
export const studentCourseDetailApi = (data: studentCourseDetailInter) => {
  return service({
    url: "/api/v1/order/item/student_course",
    method: "post",
    data,
  });
};
// 获取课程规格列表
interface courseSpecListData {
  course_id: number;
}
export const courseSpecList = (params: courseSpecListData) => {
  return service({
    url: "/api/v1/course/spec/list",
    method: "get",
    params,
  });
};
// 删除课程规格
interface deleteCourseSpecData {
  course_id: number;
  course_spec_id: number;
}
export const deleteCourseSpec = (data: deleteCourseSpecData) => {
  return service({
    url: "/api/v1/course/spec/del",
    method: "post",
    data,
  });
};
// 删除课程
interface deleteCourseData {
  course_id: number;
}
export const deleteCourse = (data: deleteCourseData) => {
  return service({
    url: "/api/v1/course/del",
    method: "post",
    data,
  });
};
// 添加套餐
interface createSetData {
  name: string;
  remark?: string;
  item: {
    type: number;
    product_id: number;
    spec_id: number;
    quantity: string;
    discount_type: number;
    discount: string;
  }[];
}
export const createSet = (data: createSetData) => {
  return service({
    url: "/api/v1/combo/create",
    method: "post",
    data,
  });
};
// 编辑套餐
interface editSetData {
  name: string;
  remark?: string;
  item: {
    type: number;
    product_id: number;
    spec_id: number;
    quantity: string;
    discount_type: number;
    discount: string;
    item_id: number;
  }[];
  combo_product_id: number;
}
export const editSet = (data: editSetData) => {
  return service({
    url: "/api/v1/combo/modify",
    method: "post",
    data,
  });
};
// 套餐列表
interface setListData {
  page?: number;
  page_size?: number;
  name?: string;
  status?: number;
}
export const setList = (params: setListData) => {
  return service({
    url: "/api/v1/combo/list",
    method: "get",
    params,
  });
};
// 套餐详情
interface setDetailData {
  combo_product_id: number;
}
export const setDetail = (params: setDetailData) => {
  return service({
    url: "/api/v1/combo/detail",
    method: "get",
    params,
  });
};
// 更变套餐状态
interface changeSetStatusData {
  combo_product_id: number;
  status: number;
}
export const changeSetStatus = (data: changeSetStatusData) => {
  return service({
    url: "/api/v1/combo/modify/status",
    method: "post",
    data,
  });
};
// 删除套餐目录
interface deleteSetItemData {
  combo_product_id: number;
  item_id: number;
}
export const deleteSetItem = (data: deleteSetItemData) => {
  return service({
    url: "/api/v1/combo/item/del",
    method: "post",
    data,
  });
};
// 修改套餐排序
interface changeSetSortData {
  combo_product_id: number;
  sort: number;
}
export const changeSetSort = (data: changeSetSortData) => {
  return service({
    url: "/api/v1/combo/modify/sort",
    method: "post",
    data,
  });
};
// 获取关联套餐列表（关闭课程调用）
interface setRelateCourseData {
  course_id: number;
}
export const setRelateCourse = (params: setRelateCourseData) => {
  return service({
    url: "/api/v1/combo/course/list",
    method: "get",
    params,
  });
};
// 检查课程是否存在未结课学员
interface checkCourseStudentData {
  course_id: number;
}
export const checkCourseStudent = (params: checkCourseStudentData) => {
  return service({
    url: "/api/v1/course/check/student_count",
    method: "get",
    params,
  });
};
// 修改课程排序
interface changeCourseSortData {
  course_id: number;
  sort: number;
}
export const changeCourseSort = (data: changeCourseSortData) => {
  return service({
    url: "/api/v1/course/modify/sort",
    method: "post",
    data,
  });
};
// 获取科目关联课程
interface subjectRelatecourseData {
  subject_id: number;
}
export const subjectRelatecourse = (params: subjectRelatecourseData) => {
  return service({
    url: "/api/v1/course/subject/list",
    method: "get",
    params,
  });
};
// 获取课程默认图片
export const subjectDefaultInfo = () => {
  return service({
    url: "/api/v1/course/default/img",
    method: "get",
  });
};

// 修改课程显示状态
interface setCourseVisibleData {
  course_id: number;
  is_show: number;
}
export const setCourseVisibleApi = (data: setCourseVisibleData) => {
  return service({
    url: "/api/v1/course/modify/show",
    method: "post",
    data,
  });
};

// 课程列表（查看是否支持购买）
interface courseSearchListData {
  page?: number;
  page_size?: number;
  course_ids?: any[];
}
export const courseListApi = (params: courseSearchListData) => {
  return service({
    url: "/api/v1/course/search/list",
    method: "get",
    params,
  });
};

// 课包选择列表
interface selectCoursePackageI {
  page: number;
  page_size: number;
  name?: string;
  status?: number;
}
export const selectCoursePackageApi = (params: selectCoursePackageI) => {
  return service({
    url: "/api/v1/course/package/select_list",
    method: "get",
    params,
  });
};
// 课包列表
interface getCoursePackageListI {
  page: number;
  page_size: number;
  name?: string;
  status?: number;
  quantity_1?: number;
  quantity_2?: number;
}
export const getCoursePackageListApi = (params: getCoursePackageListI) => {
  return service({
    url: "/api/v1/course/package/list",
    method: "get",
    params,
  });
};
// 课包详情
interface getCoursePackageDetailI {
  package_id: number;
}
export const getCoursePackageDetailApi = (params: getCoursePackageDetailI) => {
  return service({
    url: "/api/v1/course/package/detail",
    method: "get",
    params,
  });
};
// 课包创建
interface createCoursePackageI {
  name: string;
  quantity: number;
  price_1v1: string;
  price_1vn: string;
  status: number;
  relation_type: number;
  description?: string;
  course_ids?: number[];
}
export const createCoursePackageApi = (data: createCoursePackageI) => {
  return service({
    url: "/api/v1/course/package/create",
    method: "post",
    data,
  });
};
// 课包编辑
interface editCoursePackageI {
  package_id: number;
  name: string;
  quantity: number;
  price_1v1: string;
  price_1vn: string;
  status: number;
  relation_type: number;
  description?: string;
  course_ids?: number[];
}
export const editCoursePackageApi = (data: editCoursePackageI) => {
  return service({
    url: "/api/v1/course/package/edit",
    method: "post",
    data,
  });
};
// 课包删除
interface deleteCoursePackageI {
  package_id: number;
}
export const deleteCoursePackageApi = (data: deleteCoursePackageI) => {
  return service({
    url: "/api/v1/course/package/delete",
    method: "post",
    data,
  });
};
// 课包规格搜索
interface searchCoursePackageSpecI {
  page?: number;
  page_size?: number;
  package_id?: number;
  course_id?: number;
  subject_id?: number;
  course_type?: number;
}
export const searchCoursePackageSpecApi = (
  params: searchCoursePackageSpecI
) => {
  return service({
    url: "/api/v1/course/package/spec_search",
    method: "get",
    params,
  });
};
// 获取关联全部课程课包规格
export const getRelateCoursePackageSpecApi = () => {
  return service({
    url: "/api/v1/course/package/all_course_spec",
    method: "get",
  });
};
